import  React,{useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "../../../../lib/axios";
import TableComponent from '../../../../atoms/TableComponent/DataTable'; 
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { Box, Button, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const columns = [
  { id: 'RowNum', label: 'Sr.No.', minWidth: 170 },
  { id: 'PropName', label: 'Property', minWidth: 100 },
  { id: 'PlanName', label: 'Plan', minWidth: 100 },
  { id: 'PlanTenur', label: 'Tenur', minWidth: 100 },
  { id: 'FreeMonth', label: 'FreeMth', minWidth: 100 },
  { id: 'LastAdjMonths', label: 'AdjMths', minWidth: 170 },
  { id: 'MinAdjMonths', label: 'MinAdjMths', minWidth: 170 },
  { id: 'BalChargMonth', label: 'BalChargMth', minWidth: 100 },
  { id: 'DepositAmt', label: 'Deposit', minWidth: 100 },
  { id: 'TotalInstall', label: 'Installment', minWidth: 100 },
  { id: 'IncRentPerc', label: 'Increment', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 },
  { id: 'Status', label: 'Status', minWidth: 100 }
];

export default function RoomPropertyListTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRoomPlanData();
  }, []);

  const permissions = usePermissions("Payment Plan Master");

  const { AddRec = "0" } = permissions || {};

  const handlePermittedClick = () => {
    if (AddRec === "1") {
      handleClick();
    }
  };

  const fetchRoomPlanData = async () => {

    try {
      const response = await axios.post(
        'MstRoomPlan/getAllMstRoomPlanDashBoard', 
      {
        start: 1,
        PageSize: 1,
        SearchText: "Dtl"
      }
    );
      
      if (response.data.Status === 0) {

        const formattedData = response.data.Data.map(roomPlan => ({
          ...roomPlan,
          Remark: roomPlan.Remark || '',
          PlanName: roomPlan.PlanName || '',
          PlanTenur: roomPlan.PlanTenur || '',
          FreeMonth: roomPlan.FreeMonth || '',
          LastAdjMonths: roomPlan.LastAdjMonths || '',
          MinAdjMonths: roomPlan.MinAdjMonths || '',
          BalChargMonth: roomPlan.BalChargMonth || '',
          IncRentPerc: roomPlan.IncRentPerc || '',
          DepositAmt: roomPlan.DepositAmt || '',
          TotalInstall: roomPlan.TotalInstall || '',
          Status: roomPlan.Status === null ? '' : (roomPlan.Status == 1 ? 'Active' : 'Inactive')
        }));
        setRows(formattedData);
      } else {
        console.error('Error fetching RoomPlan Data:', response.data.Message);
      }
    } catch (error) {
      console.error('Error fetching RoomPlan Data:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    navigate('/roomPlanMaster');
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);

  const handleRowDoubleClick = (row) => {
  
    navigate('/roomPlanMaster', { state: { RoomPlanID: row.RoomPlanID, mode: 'view' } } );
  };
  
  const handleLocationclick=()=>{
    navigate('/masters/company')
  }

  const addButtonStyles = {
    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
    borderRadius: "50px",
    padding: "8px 20px",
    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
    transition: "background 0.3s ease",
    "&:hover": {
      background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    }
  };
 
  const Filters = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Tooltip 
        title={AddRec !== "1" ? "You have no permission to add record" : ""}
        placement="top"
      >
        <span> 
          <Button
            variant="contained"
            onClick={handlePermittedClick}
            size="small"
            disabled={AddRec !== "1"}
            sx={addButtonStyles}
          >
            <AddIcon /> New
          </Button>
        </span>
      </Tooltip>
    </Box>
  );

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      filteredRows={filteredRows}
      page={page}
      title="Company"
      titleMaster="Payment Plan Master"
      rowsPerPage={rowsPerPage}
      FiltersJsx={Filters}
      handleRowDoubleClick={handleRowDoubleClick}
      handleSearchChange={handleSearchChange}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleClick={handleClick}
      handleHomeClick={handleHomeClick}
      handleLocationclick={handleLocationclick}
    />
  );
}